import dayjs from "dayjs";
import { DATE_MESSAGES, DATE_FORMAT } from "./Constants";

// Function to validate the end date based on the start date
export const validateEndDate = (startDate, endDate) => {
  // Check if the end date is empty
  if (!endDate) {
    return Promise.reject(new Error(DATE_MESSAGES.EMPTY_END_DATE));
  }

  const start = dayjs(startDate, DATE_FORMAT, true);
  const end = dayjs(endDate, DATE_FORMAT, true);

  // Validate the end date format
  if (!end.isValid()) {
    return Promise.reject(new Error(DATE_MESSAGES.INVALID_DATE_FORMAT));
  }

  // Validate if the end date is before the start date
  if (end.isBefore(start)) {
    return Promise.reject(new Error(DATE_MESSAGES.END_DATE_BEFORE_START_DATE));
  }

  // Validate if the end date is the same as the start date
  if (end.isSame(start, "day")) {
    return Promise.reject(new Error(DATE_MESSAGES.END_DATE_SAME_AS_START_DATE));
  }

  // Ensure there's at least a one-year gap or more
  const oneYearLater = start.add(1, "year");
  if (end.isBefore(oneYearLater)) {
    return Promise.reject(new Error(DATE_MESSAGES.END_DATE_MIN_ONE_YEAR_GAP));
  }

  return Promise.resolve();
};

// Set the upper limit to December 31, 2050
export const upperLimit = dayjs("2050-12-31");

// Set the lower limit to two years before today
export const lowerLimit = dayjs().subtract(2, "years");

// Disable dates before lowerLimit or after upperLimit
export const disableDateRange = (current) => {
  return (
    (current && current.isBefore(lowerLimit.startOf("day"))) || // Disable dates before lowerLimit
    (current && current.isAfter(upperLimit.endOf("day"))) // Disable dates after upperLimit
  );
};

// Function to validate the start date
export const validateStartDate = (startDate) => {
  // Check if the start date is empty
  if (!startDate) {
    return Promise.reject(new Error(DATE_MESSAGES.EMPTY_START_DATE));
  }

  const start = dayjs(startDate, DATE_FORMAT, true);
  const now = dayjs();

  // Validate the start date format
  if (!start.isValid()) {
    return Promise.reject(new Error(DATE_MESSAGES.INVALID_DATE_FORMAT));
  }

  // Check if the start date is a future year
  const currentYear = now.year();
  const startYear = start.year();

  if (startYear > currentYear) {
    return Promise.reject(new Error(DATE_MESSAGES.START_DATE_FUTURE_YEAR));
  }

  return Promise.resolve();
};
